export const Code = {
  extends: 'CodeWithTitleAndButtons',
  flow: 'y',
  minWidth: 'H',
  maxWidth: '50%',
  '@tabletS': {
    width: 'max-content',
    widthRange: 'auto',
  },
};